import * as React from 'react'
import { InnerContainer } from '../../../../shared/components/Elements'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import { breakpoint, styled } from '../../../../shared/styled-components'

interface IProps {
  onSendReport?: () => any
}

export const ResultHeader = ({ onSendReport }: IProps) => {
  return (
    <Container>
      <InnerContainer>
        <FlexContainer>
          <Left>
            <Logo src={Utils.getAssetPath('/assets/calculator/result/logo-header.svg')} />
            <ReportHeadline>Ihr persönlicher Analysebericht</ReportHeadline>
          </Left>
          <Right>
            <ReportLink onClick={onSendReport}>
              <MailIcon src={Utils.getAssetPath('/assets/calculator/result/mail.svg')} />
              <ReportLinkTexts>
                <ReportLinkCTA>Analysebericht als PDF anfordern</ReportLinkCTA>
                <ReportLinkText>Bericht per Mail anfordern und für die Zukunft speichern</ReportLinkText>
              </ReportLinkTexts>
            </ReportLink>
            <ToothImage src={Utils.getAssetPath('/assets/calculator/result/implatooth.svg')} />
          </Right>
        </FlexContainer>
      </InnerContainer>
    </Container>
  )
}

const Container = styled.div`
  background: ${(props) => props.theme.blueColor};
  padding: 10px 0;
  background-size: cover;
  background-image: url(${Utils.getAssetPath('https://implacheck.de/img/topbar-endcard-implantatkostenrechner.jpg')});
  @media (max-width: 950px) {
    padding: 20px;
  }
  @media (max-width: 600px) {
    background-image: none;
    padding: 0;
    
  }
  @media print {
   background-color: ${(props) => props.theme.DarkblueColor} !important;
   -webkit-print-color-adjust: exact;
   -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */ 
 }
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
`

const Logo = styled.img`
  width: 200px;
  @media (max-width: 600px) {
    margin: 0 0 0 20px;
    padding-top: 10px;
    width: 150px;
 }
`

const Right = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const ReportLink = styled.a`
  display: flex;
  flex-direction: row;
  background: ${(props) => props.theme.goldColor};
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  @media (max-width: 600px) {
    border-radius: 0;
    flex-direction: column;
    position: absolute;
    margin-top: 283px;
    width: 30vw;
    right: 0;
    border-radius: 10px 0 0 10px;
  }
  @media (max-width: 370px) {
  width: 26vw
  }
  @media print {
  display: none;
  }
`

const MailIcon = styled.img`
  margin-right: 1rem;
  @media (max-width: 600px) {
    width: 30px;
    margin: 0 auto;
  }
  @media print { 
  display: none;
  }
`

const ReportLinkTexts = styled.div`
  display: flex;
  flex-direction: column;
`

const ReportLinkCTA = styled.div`
  font-weight: bold;
  color: white;
  font-size: 22px;
 @media (max-width: 950px) {
    font-size: 18px;
  }
  @media (max-width: 600px) {
    font-size: 11px;
    text-align: center;
  }
  @media print {
  display: none;
  }

`

const ReportLinkText = styled.div`
  color: ${(props) => props.theme.blueColor};
  font-size: 12px;
  @media (max-width: 600px) {
    display: none;
  }
  @media print {
  display: none;
  }
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const ReportHeadline = styled.h1`
  color: ${(props) => props.theme.greenColor};
  font-size: 30px;
  font-weight: bold;
  margin-top: 1rem;
 @media (max-width: 950px) {
    font-size: 20px;
  }
  @media (max-width: 600px) {
    text-align: left;
    margin-bottom: 20px;
    padding-left: 20px;
  }
`

const ToothImage = styled.img`
  width: 80px;
  margin-left: 10px;
  @media (max-width: 600px) {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 50px;
  } 
`

